import { useMutation } from '@tanstack/react-query';
import fileDownload from 'react-file-download';

import { downloadFlightTraces } from '~/services/FlightsService';

function getFilenameFromContentDisposition(contentDisposition: string | null): string | undefined {
  if (!contentDisposition) {
    return undefined;
  }

  const encodedFilename = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (encodedFilename) {
    return decodeURIComponent(encodedFilename);
  }

  return contentDisposition.match(/filename="?([^";]+)"?/i)?.[1];
}

export function useDownloadFlightTraces() {
  return useMutation({
    mutationFn: async (reservationId: string) => {
      const response = await downloadFlightTraces(reservationId);
      const contentDisposition = response.headers.get('Content-Disposition');
      const blob = await response.blob();
      const filename = getFilenameFromContentDisposition(contentDisposition) ?? `flight-traces-${reservationId}.zip`;

      fileDownload(blob, filename);
    },
  });
}
